// extracted by mini-css-extract-plugin
module.exports = {"search":"search_search__2OktL","icon":"search_icon__2Vi8R","input":"search_input__23CGj","button":"search_button__3nXXk"};